import React, {Fragment} from "react"
import {EstarMenuItem} from "root/Components/Sidebar/EstarMenuItem";
import EstarMenuGroup from "root/Components/Sidebar/EstarMenuGroup";
const SidebarMenuRenderer = ({groups}) =>
{
    return groups.map((item, i) =>
    {
        if (!item.isGrouped)
        {
            const items = item.items;

            return (
                items.map((item, i) =>
                {
                    return <EstarMenuItem key={item.keyName} {...item} />
                })
            )
        }
        else
        {
            return <Fragment key={item.groupName}>
                <EstarMenuGroup key={item.keyName} icon={item.icon} text={item.groupName} group={item} />
            </Fragment>
        }
    });
}

export default SidebarMenuRenderer ;